// @ts-nocheck
import React, { useEffect, useState } from "react";
import BlogTemplate from "./BlogTemplate";
import { BlogData } from "./BlogData";
import { useParams } from "react-router-dom";
import InsightSwitcher from "../Components/InsightsSwitcher/InsightSwitcher";
import SubsCribeBanner from "../Components/SubscribeBanner/SubsCribeBanner";

const Blog = () => {
  const { blogname } = useParams();
  const [data, setData] = useState(BlogData[blogname]);

  return (
    <div class="insight-page-cnt">
      <InsightSwitcher />
      <BlogTemplate  heading={data.heading} content={data.content} />
      <SubsCribeBanner />
    </div>
  );
};

export default Blog;
